import { Box, Drawer, IconButton } from "@mui/material";
import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Iconify from "src/components/iconify/Iconify";
import Logo from "../../../components/logo";
import NavSection from "../../../components/nav-section";
import Scrollbar from "../../../components/scrollbar";
import useResponsive from "../../../hooks/useResponsive";
import { appConfig, arcadeConfig, homeConfig, newsConfig, storeConfig, videoConfig } from "./mainConfig";

Nav.propTypes = {
	openNav: PropTypes.bool,
	onCloseNav: PropTypes.func,
};

export default function Nav({ openNav, onCloseNav }: any) {
	const NAV_WIDTH = 220;
	const COLLAPSE_WIDTH = 80;
	const { pathname } = useLocation();
	const isDesktop = useResponsive("up", "lg", "xl");
	// const isSmallScreen = useResponsive("down", 500);

	const [collapse, setCollapse] = useState(false);

	useEffect(() => {
		if (openNav) {
			onCloseNav();
		}
	}, [pathname]);

	const renderContent = (
		<Scrollbar
			sx={{
				height: 1,
				"& .simplebar-content": {
					height: 1,
					display: "flex",
					flexDirection: "column",
				},
			}}
		>
			<Box
				sx={{
					p: 0,
					display: "flex",
					alignItems: "center",
					justifyContent: "space-between",
					position: "relative",
				}}
			>
				<Box
					sx={{
						opacity: collapse ? 0 : 1,
						transition: collapse ? "opacity 0.15s ease-in-out" : "opacity 0.2s ease-in-out 0.3s",
						visibility: collapse ? "hidden" : "visible",
						flex: collapse ? 0 : 1,
						minWidth: collapse ? 0 : "auto",
						overflow: "hidden",
					}}
				>
					<Logo />
				</Box>
				<IconButton
					onClick={() => setCollapse((prev) => !prev)}
					sx={{
						position: collapse ? "absolute" : "static",
						left: collapse ? "50%" : "auto",
						transform: collapse ? "translateX(-50%)" : "none",
					}}
				>
					<Iconify icon={collapse ? "eva:arrow-ios-forward-fill" : "eva:arrow-ios-back-fill"} />
				</IconButton>
			</Box>
			<NavSection data={homeConfig} collapse={collapse} />
			<NavSection data={appConfig} collapse={collapse} title="App" />
			<NavSection data={arcadeConfig} collapse={collapse} title="Arcade" />
			<NavSection data={storeConfig} collapse={collapse} title="Store" />
			{/* <NavSection
        data={prizeDrawConfig}
        collapse={collapse}
        title='Prize Draws'
      /> */}
			<NavSection data={newsConfig} collapse={collapse} title="News" />
			<NavSection data={videoConfig} collapse={collapse} title="Videos" />
			<Box sx={{ flexGrow: 1 }} />
		</Scrollbar>
	);

	return (
		<Box
			component="nav"
			sx={{
				flexShrink: { lg: 0 },
				width: { lg: collapse ? COLLAPSE_WIDTH : NAV_WIDTH },
				transition: (theme) =>
					theme.transitions.create("width", {
						easing: theme.transitions.easing.sharp,
						duration: theme.transitions.duration.standard,
					}),
			}}
		>
			{isDesktop ? (
				<Drawer
					open
					variant="permanent"
					PaperProps={{
						sx: {
							width: collapse ? COLLAPSE_WIDTH : NAV_WIDTH,
							bgcolor: "background.default",
							borderRightStyle: "dashed",
							overflowX: "hidden",
							transition: (theme) =>
								theme.transitions.create("width", {
									easing: theme.transitions.easing.sharp,
									duration: theme.transitions.duration.standard,
								}),
						},
					}}
				>
					{renderContent}
				</Drawer>
			) : (
				<Drawer
					open={openNav}
					onClose={onCloseNav}
					ModalProps={{ keepMounted: true }}
					PaperProps={{
						sx: {
							width: NAV_WIDTH,
						},
					}}
				>
					{renderContent}
				</Drawer>
			)}
		</Box>
	);
}
